__turbopack_context__.v({
  "heatApp": "Input-module-scss-module__1-ZL2W__heatApp",
  "olandschokladApp": "Input-module-scss-module__1-ZL2W__olandschokladApp",
});
